import always from './always';

/**
 * A function that always returns `false`. Any passed in parameters are ignored.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Function
 * @sig * -> Boolean
 * @param {*}
 * @return {Boolean}
 * @see R.always, R.T
 * @example
 *
 *      R.F(); //=> false
 */
var F = /*#__PURE__*/always(false);
export default F;


//////////////////
// WEBPACK FOOTER
// ./~/vue-ramda/~/ramda/es/F.js
// module id = 2537
// module chunks = 1